import React from 'react';
import { CalendarDays, Check } from 'lucide-react';
import { formatLongDate, formatSignedInr, getDateState } from '../../../utils/gmpBoard';

const STEPS = [
  { key: 'open', label: 'Bidding Opens', dateKey: 'openOn', gmpKey: 'openDayGmp' },
  { key: 'close', label: 'Bidding Closes', dateKey: 'closeOn', gmpKey: 'closeDayGmp' },
  { key: 'boa', label: 'Basis of Allotment', dateKey: 'boaOn' },
  { key: 'listing', label: 'Listing Day', dateKey: 'listingOn' },
];

const STATE_STYLES = {
  done: { bar: 'bg-[#008080]', chip: 'bg-teal-50 text-[#006666] border-teal-200', text: 'Completed' },
  today: { bar: 'bg-rose-500', chip: 'bg-rose-50 text-rose-600 border-rose-200', text: 'Today' },
  upcoming: { bar: 'bg-slate-200', chip: 'bg-slate-50 text-slate-500 border-slate-200', text: 'Upcoming' },
  unknown: { bar: 'bg-slate-100', chip: 'bg-slate-50 text-slate-400 border-slate-200', text: 'Date TBA' },
};

export const CompanyIpoTimeline = ({ row }) => (
  <section aria-labelledby="gmp-timeline" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-6">
    <h2 id="gmp-timeline" className="flex items-center gap-2 text-base font-extrabold text-slate-900">
      <CalendarDays className="w-4 h-4 text-[#008080]" />
      IPO Timeline
    </h2>

    <ol className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 mt-4">
      {STEPS.map((step, index) => {
        const iso = row[step.dateKey];
        const state = getDateState(iso);
        const style = STATE_STYLES[state];
        const dayGmp = step.gmpKey ? row[step.gmpKey] : null;

        return (
          <li
            key={step.key}
            className={`relative rounded-xl border p-4 pt-5 overflow-hidden ${
              state === 'today' ? 'border-rose-200 bg-rose-50/40' : 'border-slate-200 bg-slate-50/40'
            }`}
            aria-current={state === 'today' ? 'step' : undefined}
          >
            <span className={`absolute inset-x-0 top-0 h-1 ${style.bar}`} aria-hidden="true" />
            <div className="flex items-center justify-between gap-2">
              <span className="w-6 h-6 rounded-full bg-white border border-slate-200 text-[11px] font-bold text-slate-500 flex items-center justify-center">
                {state === 'done' ? <Check className="w-3.5 h-3.5 text-[#008080]" /> : index + 1}
              </span>
              <span className={`px-2 py-0.5 rounded-full border text-[10px] font-bold uppercase tracking-wide ${style.chip}`}>
                {style.text}
              </span>
            </div>
            <div className="mt-3 text-xs font-bold text-slate-500 uppercase tracking-wider">{step.label}</div>
            <div className="mt-1 text-sm font-extrabold text-slate-900">{formatLongDate(iso) || 'To be announced'}</div>
            {dayGmp !== null && dayGmp !== undefined && (
              <div className="mt-2 inline-flex px-2 py-0.5 rounded-md bg-white border border-slate-200 text-[11px] font-semibold text-slate-600">
                GMP that day: {formatSignedInr(dayGmp)}
              </div>
            )}
          </li>
        );
      })}
    </ol>
  </section>
);

export default CompanyIpoTimeline;
